var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',_vm._b({attrs:{"depressed":"","width":"100%"},on:{"click":_vm.callAction}},'v-btn',_vm.vBtnAttr,false),[_c('span',[_vm._v(_vm._s(_vm._f("t")(_vm.label)))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }